import { render, staticRenderFns } from "./SchoolLvsSettings.vue?vue&type=template&id=2d18c282"
import script from "./SchoolLvsSettings.ts?vue&type=script&lang=ts&external"
export * from "./SchoolLvsSettings.ts?vue&type=script&lang=ts&external"
import style0 from "./SchoolLvsSettings.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports